import React from 'react';
import { FaFacebookF, FaInstagram, FaTiktok } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-dark-950 border-t border-dark-800 py-12 sm:py-16">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-10">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="font-brand text-lg text-white">FITXBYDORCA</span>
            <p className="mt-3 text-sm text-dark-400 leading-relaxed max-w-xs">
              Coaching online personalizat de fitness si nutritie. Rezultate reale, sustinute de un sistem care se adapteaza la viata ta.
            </p>
          </div>

          {/* Nav */}
          <div>
            <h3 className="text-sm font-semibold text-dark-300 uppercase tracking-wider mb-4">Navigare</h3>
            <ul className="space-y-2.5 text-sm">
              <li><a href="#hero" className="text-dark-400 hover:text-white transition-colors">Acasa</a></li>
              <li><a href="#beneficii" className="text-dark-400 hover:text-white transition-colors">Beneficii</a></li>
              <li><a href="#testimoniale" className="text-dark-400 hover:text-white transition-colors">Testimoniale</a></li>
              <li><a href="#galerie" className="text-dark-400 hover:text-white transition-colors">Galerie</a></li>
              <li><a href="#contact" className="text-dark-400 hover:text-white transition-colors">Contact</a></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-sm font-semibold text-dark-300 uppercase tracking-wider mb-4">Legal</h3>
            <ul className="space-y-2.5 text-sm">
              <li><a href="/privacy" className="text-dark-400 hover:text-white transition-colors">Politica de confidentialitate</a></li>
              <li><a href="/cookies" className="text-dark-400 hover:text-white transition-colors">Politica Cookies</a></li>
              <li><a href="/terms" className="text-dark-400 hover:text-white transition-colors">Termeni si conditii</a></li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h3 className="text-sm font-semibold text-dark-300 uppercase tracking-wider mb-4">Social</h3>
            <div className="flex items-center gap-3">
              <a href="https://www.facebook.com/dorca.catalin" aria-label="Facebook" className="w-9 h-9 flex items-center justify-center rounded-lg bg-dark-800 text-dark-400 hover:text-white hover:bg-dark-700 transition-colors">
                <FaFacebookF size={14} />
              </a>
              <a href="https://www.instagram.com/catalin_dorca.pt/" aria-label="Instagram" className="w-9 h-9 flex items-center justify-center rounded-lg bg-dark-800 text-dark-400 hover:text-white hover:bg-dark-700 transition-colors">
                <FaInstagram size={14} />
              </a>
              <a href="https://www.tiktok.com/@catalin.dorca.pt" aria-label="TikTok" className="w-9 h-9 flex items-center justify-center rounded-lg bg-dark-800 text-dark-400 hover:text-white hover:bg-dark-700 transition-colors">
                <FaTiktok size={14} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-dark-800 pt-6 text-center">
          <span className="text-xs text-dark-500">
            &copy; {new Date().getFullYear()} Catalin Dorca. Toate drepturile rezervate.
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
